import { render } from "./PreviewRenderer.vue?vue&type=template&id=d22e2c56&scoped=true"
import script from "./PreviewRenderer.vue?vue&type=script&lang=ts"
export * from "./PreviewRenderer.vue?vue&type=script&lang=ts"

import "./PreviewRenderer.vue?vue&type=style&index=0&id=d22e2c56&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d22e2c56"

export default script